export const rootstechExpoPreshowMS = 1614211200000 // Wed Feb 24 2021 5:00pm UTC-7)
export const rootstechMainStageCountdownVideoMs = 1614218400000 // Wed Feb 24 2021  at 7:00pm UTC-7)
export const rootstechStartMS = 1614225600000 // Wed Feb 24 2021  at 9:00pm UTC-7)
export const rootstechEndMS = 1614452400000
